<template>
    <div class="table-tr">
        <div class="table-td cell-word-review">
            <strong>{{ startAndEndDate }}</strong>
        </div>

        <div class="table-td cell-duration">
            {{ __choice("{0} :days days|{1} :days day|[2,4] :days days|[5,*] :days days", duration, { 'days': duration }) }}
        </div>

        <div class="table-td cell-patient">
            <div v-if="vacation.substitute" class="profile">
                <UserAvatar :user-info="vacation.substitute.user" size="sm" />
                <div class="profile-name">
                    <span>{{ vacation.substitute.user | fullname }}</span>
                </div>
            </div>
            <div v-else>
                <span>{{ __('Without a substitute') }}</span>
            </div>
        </div>
        <div class="table-td dropdowns">
            <div class="control-dropdown">
                <button aria-expanded="false" aria-haspopup="true" class="control-button" data-toggle="dropdown" type="button">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <div class="controls-wrapper">
                    <nav class="controls-nav">
                        <ul>
                            <li v-if="vacation.status === 'future'">
                                <a
                                    data-dismiss="modal"
                                    data-target="#modal-edit-vacation"
                                    data-toggle="modal"
                                    href="#"
                                    @click.prevent="$emit('edit')"
                                >
                                    <figure>
                                        <span class="material-icons">edit</span>
                                    </figure>
                                    <strong>{{ __('Edit') }}</strong>
                                </a>
                            </li>
                            <li>
                                <a data-dismiss="modal"
                                    data-target="#modal-delete-vacation"
                                    data-toggle="modal"
                                    data-vacation-id="vacation.id"
                                    href="#"
                                    @click.prevent="$emit('remove')"
                                >
                                    <figure>
                                        <span class="material-icons-outlined">delete</span>
                                    </figure>
                                    <strong>{{ __('Delete') }}</strong>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vacation: {
            type: Object,
            required: true
        }
    },
    computed: {
        startDate() {
            return moment(this.vacation.start_date)
        },
        endDate() {
            return moment(this.vacation.end_date)
        },
        startAndEndDate() {
            const format = []
            
            format.push(this.startDate.format('D. '))

            if (this.startDate.format('MM') !== this.endDate.format('MM')) {
                format.push(monthNameDeclension(this.startDate.format('M')))
            }

            format.push(' - ')
            format.push(this.endDate.format('D. '))
            format.push(monthNameDeclension(this.endDate.format('M')))
            format.push(this.endDate.format(' YYYY'))

            return format.join('')
        },
        duration() {
            return this.endDate.diff(this.startDate, 'days') + 1
        }
    }
}
</script>
